import "../css/goldrateWork.css";

import PageHeader from "../components/ratework/Header";
import FiltersBar from "../components/ratework/Filterbar";
import TradeForm from "../components/ratework/RateForm";
import DateFilterPanel from "../components/ratework/DateFilterPanel";
import TradeTable from "../components/ratework/TradeTable";
import SubmitSection from "../components/ratework/SubmitSection";
import { useEffect, useState } from "react";
import useCustomers from "../hook/useCustomers";
import ExportActionButtons from "../components/ratework/ExportActionButtons";
import {
  createTransaction,
  getTxSerialNumber,
  pendingTransactions,
  pendingTransactionsByDate,
} from "../services/transactionService";
import {
  buySellTxResponseTransform,
  getPayload,
  proccessedPayload,
  processItem,
  transactionValidation,
} from "../utils/ratework.util";
import ErrorModal from "../components/common/ErrorModal";
import SuccessModal from "../components/common/SuccessModal";
import { getRateWorkReport } from "../services/reportService";
import TradeTableView from "../components/ratework/TradeTableView";

const getInitial = () => ({
  description: "",
  weight: "",
  rwType: "Ready",
  rate: "",
  amount: "",
  status: "D&L",
  diff: "",
  postDate: new Date(),
  originalAmount: "",
});
export default function RateWorkPage({ headerLabel = "Gold" }) {
  const sectionGoldOrSilver = headerLabel === "Gold" ? "gold" : "silver";

  const { customers } = useCustomers();
  const [header, setHeader] = useState({
    serial: "----",
    date: new Date().toISOString().split("T")[0],
    time: new Date().toTimeString().slice(0, 5),
    selectedCustomer: null,
    satisfaction: "satisfied",
  });

  const [buyStates, setBuyStates] = useState(getInitial());
  const [sellStates, setSellStates] = useState(getInitial());

  const [errors, setErrors] = useState([]);
  const [sucessMessage, setSuccessMessage] = useState(null);

  const [submitLoadingTx, setSubmitLoadingTx] = useState(false);

  const [dates, setDates] = useState({
    from: new Date().toISOString().split("T")[0],
    to: new Date().toISOString().split("T")[0],
  });

  const [dataView, setDataView] = useState({
    buy: [],
    sell: [],
  });
  const [dataViewLoading, setDataViewLoading] = useState(false);

  const getSerialNumber = async () => {
    try {
      const resp = await getTxSerialNumber();
      if (resp.success) {
        const serial = resp.serialNumber;
        setHeader({ ...header, serial });
        return serial;
      }
    } catch (err) {
      console.log("erro loading serial number");
    }
  };

  useEffect(() => {
    initData();
    const timer = setTimeout(() => {
      handleDateApply();
    }, 500);

    return () => clearTimeout(timer);
  }, [headerLabel]);

  const initData = () => {
    setHeader({
      serial: "----",
      date: new Date().toISOString().split("T")[0],
      time: new Date().toTimeString().slice(0, 5),
      selectedCustomer: null,
      satisfaction: "satisfied",
    });
    setDataView({ buy: [], sell: [] });
    getSerialNumber();
    // handleClearData();
  };

  const handleNewData = async () => {
    try {
      const sr = header.serial;
      const date = header.date;
      const time = header.time;
      if (!header.selectedCustomer) {
        return alert("Select the customer first.");
      }
      const partyName = header.selectedCustomer.name;
      const cid = header.selectedCustomer?._id;

      const { errors, isBuyTx, isSellTx } = transactionValidation(
        buyStates,
        sellStates,
      );

      if (!isBuyTx && !isSellTx) {
        return setErrors(["Not transaction found!"]);
      }

      if (errors.length === 0) {
        const buy = isBuyTx
          ? processItem(sr, date, time, partyName, cid, buyStates)
          : null;
        const sell = isSellTx
          ? processItem(sr, date, time, partyName, cid, sellStates)
          : null;

        // console.log({ isBuyTx, isSellTx });

        await handleSubmitBtn({ buy, sell });

        setHeader({
          serial: "----",
          date: new Date().toISOString().split("T")[0],
          time: new Date().toTimeString().slice(0, 5),
          selectedCustomer: null,
          satisfaction: "satisfied",
        });

        getSerialNumber();
        handleClearData();
      } else if (errors.length > 0) {
        return setErrors(errors);
      }
    } catch (err) {}
  };

  // const addItem = (item, type) => {
  //   setNewData((prevData) => {
  //     const updatedData = { ...prevData };
  //     updatedData[type] = [...updatedData[type], item];
  //     return updatedData;
  //   });
  // };

  // const removeItemBySerial = (serialNumber, type) => {
  //   setNewData((prevData) => {
  //     const updatedData = { ...prevData };
  //     updatedData[type] = updatedData[type].filter(
  //       (item) => item.sr !== serialNumber,
  //     );
  //     return updatedData;
  //   });
  // };

  const removeItem = (serialNumber, side) => {
    removeItemBySerial(serialNumber, side);
  };

  const handleSubmitBtn = async (newData) => {
    try {
      setSubmitLoadingTx(true);
      const componentValue = sectionGoldOrSilver + "RateWork";
      const combinedTxns = proccessedPayload(newData, componentValue);

      const response = await createTransaction(combinedTxns);
      if (response.success) {
        setSuccessMessage("Transaction created successfully!");
        handleDateApply();
        setErrors([]);
      } else {
        setErrors(response.errors || ["Failed to create transaction."]);
      }
    } catch (err) {
      throw err;
    } finally {
      setSubmitLoadingTx(false);
    }
  };

  const handlePrint = (orientation = "landscape") => {
    const printContent = document.getElementById("report-section");

    const newWindow = window.open("", "", "width=1200,height=800");

    newWindow.document.write(`
  <html>
    <head>
      <title>${sectionGoldOrSilver === "gold" ? "Gold" : "Silver"} Rate Report</title>

      <style>
        @page {
          size: A4 ${orientation};
          margin: 10mm;
        }

        body {
          font-family: Arial, sans-serif;
          padding: 10px;

          /* 🔥 IMPORTANT: enable colors in print */
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .print-header {
          text-align: center;
          margin-bottom: 15px;
        }

        .print-header h1 {
          margin: 0;
          font-size: 20px;
          color: #1A237E;
        }

        .print-header p {
          margin: 2px 0;
          font-size: 12px;
          color: #555;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        th {
          background-color: #1A237E;
          color: white;
        }

        th, td {
          border: 1px solid #999;
          padding: 6px;
          text-align: center;
          white-space: nowrap;
        }

        /* Alternate rows */
        tr:nth-child(even) {
          background-color: #f5f5f5;
        }

        /* Section headings */
        .section-title {
          margin-top: 15px;
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          padding: 6px;
        }

        .buy-title {
          background-color: #2E7D32;
        }

        .sell-title {
          background-color: #C62828;
        }

        /* ❌ Hide elements in print */
        .no-print {
          display: none !important;
        }

        /* Prevent breaking inside rows */
        tr {
          page-break-inside: avoid;
        }

      </style>
    </head>

    <body>

      <!-- 🔥 HEADER -->
      <div class="print-header">
        <h1>KW Gold & Silver Lab</h1>
        <p>${sectionGoldOrSilver === "gold" ? "Gold" : "Silver"} Rate Report</p>
        <p>${new Date().toLocaleDateString()}</p>
      </div>

      ${printContent.innerHTML}

    </body>
  </html>
  `);

    newWindow.document.close();
    newWindow.focus();

    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  const handleClearData = () => {
    const r = getInitial();
    setBuyStates(r);
    setSellStates(r);
  };

  const handleDateClear = () => {
    setDataView({
      buy: [],
      sell: [],
    });
    setDates({ from: "", to: "" });
  };
  const handleDateApply = async () => {
    try {
      setDataViewLoading(true);
      const data = await pendingTransactionsByDate({
        fromDate: dates.from,
        toDate: dates.to,
        type: sectionGoldOrSilver,
      });

      // console.log({ data });

      const { receive, given } = buySellTxResponseTransform(
        data,
        sectionGoldOrSilver,
      );

      // console.log({ receive, given });

      setDataView({
        buy: receive,
        sell: given,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setDataViewLoading(false);
    }
  };

  // const handlReportGenerate = async (type) => {
  //   try {
  //     if (!dates.from && !dates.to) {
  //       return alert("Please add the from/to dates");
  //     }
  //     const isBinary = type !== "csv";

  //     const response = await getRateWorkReport(
  //       {
  //         format: type,
  //         fromDate: dates?.from,
  //         toDate: dates?.to,
  //       },
  //       {
  //         responseType: isBinary ? "arraybuffer" : "text",
  //       },
  //     );

  //     const disposition = response.headers?.["content-disposition"];

  //     let fileName = "report-rate-work";

  //     if (disposition && disposition.includes("filename=")) {
  //       fileName = disposition.split("filename=")[1].replace(/"/g, "").trim();
  //     }

  //     const MIME_TYPES = {
  //       excel:
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       csv: "text/csv;charset=utf-8;",
  //       pdf: "application/pdf",
  //     };
  //     const EXTENSIONS = { excel: "xlsx", csv: "csv", pdf: "pdf" }; // fix: xlsx not xls

  //     const blob = new Blob([response.data], { type: MIME_TYPES[type] });

  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = fileName || `ratework-report.${EXTENSIONS[type]}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     URL.revokeObjectURL(url);
  //   } catch (err) {
  //     console.error("Download failed:", err);
  //     alert("Error while downloading the file");
  //   } finally {
  //   }
  // };
  const handlReportGenerate = async (format) => {
    try {
      if (!dates.from && !dates.to) {
        return alert("Please add the from/to dates");
      }

      const isBinary = format !== "csv";

      const response = await getRateWorkReport(
        {
          format,
          fromDate: dates?.from,
          toDate: dates?.to,
        },
        {
          responseType: isBinary ? "arraybuffer" : "text",
          validateStatus: () => true, // 🔥 IMPORTANT
        },
      );

      // 🔥 HANDLE ERROR RESPONSE
      const contentType = response.headers["content-type"];

      if (contentType?.includes("application/json")) {
        const decoder = new TextDecoder();
        const text = decoder.decode(response.data);
        const error = JSON.parse(text);

        alert(error.message || "No data found");
        return;
      }

      // 🔥 SUCCESS FLOW
      const disposition = response.headers["content-disposition"];

      let fileName = "report-rate-work";

      if (disposition && disposition.includes("filename=")) {
        fileName = disposition.split("filename=")[1].replace(/"/g, "").trim();
      }

      const MIME_TYPES = {
        excel:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        csv: "text/csv;charset=utf-8;",
        pdf: "application/pdf",
      };

      const EXTENSIONS = {
        excel: "xlsx",
        csv: "csv",
        pdf: "pdf",
      };

      const blob = new Blob([response.data], {
        type: MIME_TYPES[format],
      });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || `ratework-report.${EXTENSIONS[format]}`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(url);

      // ✅ SUCCESS MESSAGE
      // alert("Report downloaded successfully ✅");
    } catch (err) {
      console.error("Download failed:", err);
      const message =
        err.response?.data?.message || "Error while downloading the report ❌";
      alert(message);
    }
  };
  return (
    <>
      <PageHeader type={headerLabel} />

      <FiltersBar
        customers={customers}
        header={header || {}}
        setHeader={setHeader}
      />

      <div className="container mt-4">
        <div className="row gx-4 gy-4">
          <div className="col-lg-6 d-flex">
            <TradeForm
              type="buy"
              headerData={header}
              onAddItem={handleNewData}
              formData={buyStates}
              setFormData={setBuyStates}
            />
          </div>

          <div className="col-lg-6 d-flex">
            <TradeForm
              type="sell"
              headerData={header}
              onAddItem={handleNewData}
              formData={sellStates}
              setFormData={setSellStates}
            />
          </div>
        </div>
        <div className="mt-2 text-end">
          <button
            className="customBtn mt-2"
            onClick={handleNewData}
            disabled={submitLoadingTx}
          >
            {submitLoadingTx ? "Submitting..." : "Submit Transaction"}
          </button>
        </div>
      </div>

      <DateFilterPanel
        dates={dates}
        setDates={setDates}
        handleDateApply={handleDateApply}
        handleDateClear={handleDateClear}
      />

      <ExportActionButtons
        handleCSV={() => handlReportGenerate("csv")}
        handleExcel={() => handlReportGenerate("excel")}
        handlePDF={() => handlReportGenerate("pdf")}
        handlePrint={() => handlePrint()}
      />

      <div id="report-section" className="mb-5">
        <TradeTable
          type="buy"
          data={dataView}
          loading={dataViewLoading}
          refetch={handleDateApply}
        />
      </div>

      <ErrorModal
        show={errors?.length > 0}
        errors={errors ? errors : []}
        onClose={() => setErrors(null)}
      />
      <SuccessModal
        show={sucessMessage !== null}
        message={sucessMessage}
        onClose={() => {
          setSuccessMessage(null);
          // Get data again after success
        }}
      />
    </>
  );
}
